const InputError = ({ error, children, className = "", ...rest }) => (
  <p {...rest} role="alert" className={`akello-field-error ${className}`}>
    <span aria-hidden="true">!</span>{error ?? children}
  </p>
);
export default InputError;
